import { ref } from "vue";

export function useConfirm() {
  // Estado local para cada instancia del composable
  const isVisible = ref(false);
  const title = ref("");
  const message = ref("");
  
  // Esta variable mantendrá la función `resolve` de la promesa
  let resolvePromise = null;
  
  const confirm = (newTitle, newMessage) => {
    title.value = newTitle;
    message.value = newMessage;
    isVisible.value = true;
  
    // Retornamos una promesa que se resolverá cuando el usuario interactúe
    return new Promise((resolve) => {
      resolvePromise = resolve;
    });
  };
  
  const onConfirm = () => {
    isVisible.value = false;
    if (resolvePromise) resolvePromise(true);
  };
  
  const onCancel = () => {
    isVisible.value = false;
    if (resolvePromise) resolvePromise(false);
  };
  
  return { isVisible, title, message, confirm, onConfirm, onCancel };
}
